import { SharedPartnerService } from '@/shared/api/services/partner/partner';
import type { Unternehmen } from '@/types/Partner';

export class PartnerService extends SharedPartnerService {
  async findeAuftraggeberNachId(
    unternehmenId: string,
    cache: boolean = false,
  ): Promise<Unternehmen> {
    return this.httpClient.get(
      `${this.partnerServiceBaseUrl}/unternehmen/auftraggeber/${unternehmenId}`,
      {
        params: { cache },
      },
    );
  }

  async hatUnternehmenSichtbeschraenkteNutzer(): Promise<boolean> {
    return this.httpClient.get(
      `${this.partnerServiceBaseUrl}/unternehmen/auftraggeber/sichtbeschraenkung`,
    );
  }

  async erstelleGesellschaft(id: string, gesellschaft: Unternehmen): Promise<Unternehmen> {
    return this.httpClient.post(
      `${this.partnerServiceBaseUrl}/unternehmen/auftraggeber/${id}/tochter`,
      { data: gesellschaft },
    );
  }
}
